import Vue from 'vue'
import store from '@/store'

// axios
import axios from 'axios'

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  baseURL: window.__env.VUE_APP_BASE_URL,
  // timeout: 1000,
  headers: {'module': 'SBO'}
})

axiosIns.interceptors.request.use(
  function (config) {

    const locale = store.getters['user/getPreferences'].lang;
    config.headers['X-localization'] = locale;

    // Add Origin header specifically for Cypress testing environment
    // This helps with CORS issues that can occur during automated testing
    if (window.Cypress && window.location && window.location.origin) {
      config.headers['Origin'] = window.location.origin;
      config.headers['Referer'] = window.location.origin;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns

export default axiosIns
